import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { QuizType, QuizTypesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class QuizTypesDataService {

  private uri: string = `${environment.apiUrl}quiz-types`;
  private cacheKey: string = 'quizTypes.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getQuizType(id: number): Observable<QuizType|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getQuizTypes(parameters: {[param: string]: string | string[]}): Observable<QuizTypesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addQuizType(data: QuizType): Observable<QuizType|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addQuizTypes(data: QuizType[]): Observable<QuizType[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateQuizType(data: QuizType): Observable<QuizType|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateQuizTypes(data: QuizType[]): Observable<QuizType[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchQuizType(data: QuizType): Observable<QuizType|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchQuizTypes(data: QuizType[]): Observable<QuizType[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteQuizType(data: QuizType): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteQuizTypes(data: QuizType[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((quizType) => {
      ids.push(quizType.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
